import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const ProvinciaService = {
  fetchProvinciasPorDepartamento: async (token, departmentId) => {
    try {
      const response = await axios.get(buildApiUrl(`/api/locations/provinces/${departmentId}`), {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      if (response.data.success) {
        return response.data.data;
      } else {
        console.error("La API no devolvió success=true");
        return [];
      }
    } catch (error) {
      console.error("Error en ProvinciaService.fetchProvinciasPorDepartamento:", error);
      throw error;
    }
  },
};
